import { inject as i } from "vue";
import { notificationApiInjectionKey as t } from "./ghl-ui.es288.js";
import { throwError as n } from "./ghl-ui.es853.js";
function c() {
  const o = i(t, null);
  return o === null && n("use-notification", "No outer `n-notification-provider` found."), o;
}
export {
  c as useNotification
};
